import { useNavigate } from "react-router-dom";
import { formatDate } from "../../../../utils/DateFormat";
import TicketPopup from "../popup/TicketPopup";
import { EstimatePopup } from "../popup/EstimatePopup";
import { ReactComponent as MoneyIcon } from "../../../../assets/icons/money.svg";
import Button from "../../components/Button";
import BackNavigationBar from "../../components/BackNavigationBar";

const PLACEHOLDER = "/images/default-profile.png";

const DesktopProfileContent = ({
  documentData,
  process = [],
  data,
  represent,
  category,
  convertProfileName,
  renderContent,
  isPrinting,
  handlePrint,
  handleOpenPopup,
  handleOpenEstimate,
  handelDuplicateProfile,
  isPopupOpen,
  handleClosePopup,
  isEstimateOpen,
  handleCloseEstimate,
  estimateData,
  estimateLoading,
  getAdjustmentHistory,
  id,
  isFromAssetList = false,
  onBackToAssetList,
}) => {
  const navigate = useNavigate();

  const date = new Date();
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return (
    <>
      {isFromAssetList && (
        <div className="hide-section">
          <BackNavigationBar
            ariaLabel="Quay lại danh sách tài sản"
            onBack={onBackToAssetList}
          />
        </div>
      )}

      <h1 className="w-full text-center font-sf-semibold profile-heading text-[#0457C2] text-[1.5rem] uppercase border-b p-4">
        {convertProfileName(data?.profile_name)}
      </h1>

      <div className="mt-10 motion-safe:animate-[fadeIn_240ms_ease-out]">
        <div className="grid grid-cols-2 xl:grid-cols-3 gap-y-6 gap-x-4 mb-8 profile-meta-grid">
          {[
            ["Số đơn:", data?.soDon || "--"],
            [
              "Ngày nộp đơn:",
              data?.createDate ? formatDate(data.createDate) : "--",
            ],
            [
              "Ngày công bố:",
              data?.dateActive ? formatDate(data.dateActive) : "--",
            ],
            ["Số bằng:", data?.soBang || "--"],
            [
              "Ngày cấp bằng:",
              data?.issueDate ? formatDate(data.issueDate) : "--",
            ],
            [
              "Ngày hết hạn:",
              data?.expiryDate ? formatDate(data.expiryDate) : "--",
            ],
            [
              category === "Nhãn hiệu" ? "Nhãn hiệu:" : "Tên hồ sơ:",
              data?.brand || "",
            ],
          ].map(([label, value], i) => (
            <div key={i} className="flex items-center meta-item">
              <strong className="mr-2 whitespace-nowrap">{label}</strong>
              <span className="whitespace-nowrap meta-value">{value}</span>
            </div>
          ))}
        </div>

        <div className="w-full flex items-center justify-center mt-8 mb-6 gap-4">
          {Array.isArray(data?.profile_image) ? (
            data.profile_image.length > 0 ? (
              data.profile_image.map((img, idx) => (
                <img
                  key={idx}
                  src={img?.value || PLACEHOLDER}
                  alt="So huu tri tue logo"
                  className="profile-logo h-[7.5rem] object-contain"
                  onError={(e) => (e.currentTarget.src = PLACEHOLDER)}
                />
              ))
            ) : (
              <img
                src={PLACEHOLDER}
                alt="So huu tri tue logo"
                className="profile-logo h-[7.5rem] object-contain"
              />
            )
          ) : (
            <img
              src={data?.profile_image || PLACEHOLDER}
              alt="So huu tri tue logo"
              className="profile-logo h-[7.5rem] object-contain"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = PLACEHOLDER;
              }}
            />
          )}
        </div>

        {renderContent(documentData)}

        {(data?.isLookup || data?.isRequire || data?.isOriginal) && (
          <div className="profile-extra-info mt-8 space-y-3 bg-blue-50/50 p-6 rounded-xl border border-blue-100">
            <h4 className="font-sf-semibold text-[#0457C2] uppercase text-sm tracking-wide">
              Thông tin bổ sung
            </h4>
            <div className="profile-extra-info-list flex flex-col gap-3">
              {data?.isOriginal && (
                <div className="profile-extra-info-item flex items-center gap-3">
                  <div className="profile-extra-dot size-2.5 rounded-full bg-blue-500 shadow-sm shadow-blue-200"></div>
                  <span className="profile-extra-text font-sf-medium text-gray-700">
                    Hồ sơ gốc tài sản trí tuệ
                  </span>
                </div>
              )}
              {data?.isLookup && (
                <div className="profile-extra-info-item flex items-center gap-3">
                  <div className="profile-extra-dot size-2.5 rounded-full bg-blue-500 shadow-sm shadow-blue-200"></div>
                  <span className="profile-extra-text font-sf-medium text-gray-700">
                    Có yêu cầu Tra cứu
                  </span>
                </div>
              )}
              {data?.isRequire && (
                <div className="profile-extra-require space-y-3">
                  <div className="profile-extra-info-item flex items-center gap-3">
                    <div className="profile-extra-dot size-2.5 rounded-full bg-blue-500 shadow-sm shadow-blue-200"></div>
                    <span className="profile-extra-text font-sf-medium text-gray-700">
                      Có yêu cầu khác
                    </span>
                  </div>
                  {data?.contentRequire && (
                    <div className="profile-extra-note ml-5.5 p-4 bg-white/80 rounded-lg border border-blue-50 text-sm text-gray-700 italic leading-relaxed shadow-sm">
                      {data.contentRequire.replace(/^"|"$/g, "")}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        )}

        <div className="profile-process-table bg-white border rounded-lg overflow-hidden mt-8">
          <h4 className="profile-process-title text-white table-heading font-sf-medium bg-[#0457C2] px-3 py-3">
            Tiến trình hồ sơ
          </h4>
          <table className="profile-process-grid w-full text-left">
            <thead>
              <tr className="profile-process-head-row bg-gray-200 font-sf-medium h-[60px]">
                <th className="px-3 py-3">STT</th>
                <th className="px-3 py-3">Nội dung xử lý</th>
                <th className="px-3 py-3">Ngày hoàn thành</th>
                <th className="px-3 py-3">Tài liệu</th>
              </tr>
            </thead>
            <tbody>
              {process?.length > 0 &&
                process.map((item, index) => (
                  <tr
                    key={`${item?.processContent || "row"}-${index}`}
                    className="hover:bg-blue-50 border-b"
                  >
                    <td className="p-3">{index + 1}</td>
                    <td className="p-3">{item?.processContent}</td>
                    <td className="p-3">{formatDate(item?.completionDate)}</td>
                    <td className="p-3 text-blue-600">
                      {item?.pdfUrl ? (
                        <a
                          href={item.pdfUrl}
                          className="hover:underline"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Tài liệu
                        </a>
                      ) : (
                        "--"
                      )}
                    </td>
                  </tr>
                ))}
              {(!process || process.length === 0) && (
                <tr>
                  <td
                    colSpan={4}
                    className="profile-process-empty p-4 text-center text-gray-400 italic"
                  >
                    Chưa có tiến trình nào được ghi nhận
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Action buttons */}
        <div
          id="download-btn"
          className="w-full flex items-center justify-center gap-3 mt-8 mb-10 hide-section"
        >
          {data?.status?.value === "Chờ duyệt" && (
            <Button
              variant="primary"
              onClick={() => {
                navigate(`/quan-ly-ho-so/ho-so/${id}/chinh-sua`);
              }}
              leftIcon={
                <img
                  src="/icons/edit.svg"
                  alt=""
                  className="size-5 object-contain"
                />
              }
              className="border-blue-500 bg-blue-500 hover:bg-blue-600"
            >
              Chỉnh sửa hồ sơ
            </Button>
          )}
          <Button
            variant="orange"
            onClick={handleOpenEstimate}
            leftIcon={<MoneyIcon className="h-auto w-6 shrink-0" />}
          >
            Chi phí
          </Button>

          <Button
            variant="darkBlue"
            onClick={handlePrint}
            leftIcon={
              <img
                src="/icons/download.svg"
                alt=""
                className="size-5 object-contain brightness-0 invert"
              />
            }
          >
            Tải hồ sơ
          </Button>
          {data?.status?.value === "Đang triển khai" && (
            <Button variant="orange" onClick={handleOpenPopup}>
              <img src="/icons/ticket.svg" alt="ticket icon" />
              Gửi yêu cầu
            </Button>
          )}
          <Button
            variant="secondary"
            onClick={handelDuplicateProfile}
            leftIcon={
              <img
                src="/icons/copy.svg"
                alt=""
                className="size-5 object-contain brightness-0 opacity-70"
              />
            }
          >
            Nhân bản hồ sơ
          </Button>
        </div>

        {isPopupOpen && (
          <TicketPopup
            isOpen={isPopupOpen}
            onClose={handleClosePopup}
            profileID={id}
            profileName={convertProfileName(data?.profile_name)}
          />
        )}

        {isEstimateOpen && estimateData && (
          <EstimatePopup
            isOpen={isEstimateOpen}
            onClose={handleCloseEstimate}
            data={estimateData}
            getAdjustmentHistory={getAdjustmentHistory}
            estimateLoading={estimateLoading}
          />
        )}

        <p className="profile-download-footer w-full text-center text-[#333333] mt-16">
          Hồ sơ được tải về ngày {`${day}/${month}/${year}`} từ Nền tảng số
          Sohuutritue.vn
          <br />
          Tổng đài tư vấn Sở hữu trí tuệ:{" "}
          <a href="tel:0819009697" className="hover:underline">
            08 1900 9697
          </a>{" "}
          (điện thoại, zalo) - Email:{" "}
          <a
            href="mailto:luatsu@sohuutritue.vn"
            className="text-blue-600 hover:underline"
          >
            luatsu@sohuutritue.vn
          </a>
        </p>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(6px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @media (prefers-reduced-motion: reduce) {
          .motion-safe\\:animate-\\[fadeIn_240ms_ease-out\\] { animation: none !important; }
          .motion-safe\\:animate-\\[fadeIn_260ms_ease-out\\] { animation: none !important; }
        }
        .pdf-only-row { display: none; }
      `}</style>
    </>
  );
};

export default DesktopProfileContent;
